let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import POS from "../../POS.js";
let BookingResourceModel = require("../../model/settings/BookingResourceModel.js");
import i18n from "../../utils/i18n";

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .booking" : "onSelectItem",
            "click .save" : "saveResource",
            "click .delete" : "deleteResource",
            "click .createNew" : "createResource",
            "click .navbar-btn": "listResource"
        },

        initialize: function() {
            if(!this.model) {
                this.model = new BookingResourceModel();
            }
        },

        render: function(evt) {
            this.$("form").removeClass("hidden");
            if(this.model.get('id')) {
                this.renderEditWindow(evt);
            } else {
                this.renderCreateWindow();
            }
            return this;
        },

        renderEditWindow: function(evt) {
            this.$('#inputName').val(this.model.get("name"));
            this.$('#inputQuantity').val(this.model.get("quantity"));
            this.$('#inputStartHour').val(this.model.get("startHour"));
            this.$('#inputStartMinute').val(this.model.get("startMinute"));
            this.$('#inputEndHour').val(this.model.get("endHour"));
            this.$('#inputEndMinute').val(this.model.get("endMinute"));
        },

        renderCreateWindow: function() {
            this.$('fieldset').attr('disabled', null);
            this.$('#inputName, #inputQuantity').val("");
            this.$('.del').addClass('hidden');
            this.$('.delete').addClass('hidden');
        },

        onSelectItem: function(evt) {
            var booking = $(evt.currentTarget);
            this.model.set({
                id: booking.data('id'),
                name: booking.attr('data-name'),
                quantity: booking.attr('data-quantity'),
                startHour: booking.attr('data-starthour'),
                startMinute: booking.attr('data-startminute'),
                endHour: booking.attr('data-endhour'),
                endMinute: booking.attr('data-endminute')
            });
            var modal = this.$('.bookingCreateModal');
            modal.find('.modal-title').text(i18n.msg("pos.settings.booking.title.edit.resource"));
            if(modal.find('.save').hasClass("saveCreate-btn")){
                modal.find('.save').removeClass('saveCreate-btn');
            }
            if(!modal.find('.save').hasClass("saveEdit-btn")){
                modal.find('.save').addClass('saveEdit-btn');
            }
            modal.modal('show');
            this.$('.del').removeClass('hidden');
            this.$('.delete').removeClass('hidden');
            this.render(evt);
        },

        createResource: function() {
            this.model.set({id: null});
            var modal = this.$('.bookingCreateModal');
            modal.find('.modal-title').text(i18n.msg("pos.settings.booking.title.add.resource"));
            if(modal.find('.save').hasClass("saveEdit-btn")){
                modal.find('.save').removeClass('saveEdit-btn');
            }
            if(!modal.find('.save').hasClass("saveCreate-btn")){
                modal.find('.save').addClass('saveCreate-btn');
            }
            this.$('.modal.bookingCreateModal').modal('show');
            this.render();
        },


        saveResource: function() {
            this.$('.form-group').removeClass('has-error').find('.help-block').text("");

            var params = {
                    name: this.$('#inputName').val(),
                    quantity: this.$('#inputQuantity').val(),
                    organizationId: POS.get('rId'),
                    startHour: this.$('.start-hour').val(),
                    startMinute: this.$('.start-minute').val(),
                    endHour: this.$('.end-hour').val(),
                    endMinute: this.$('.end-minute').val()
                },
                result = $.post('/booking/saveResource' + (this.model.get("id")?"/" + this.model.get("id"):""), params), self = this;

            var validated = true;
            if(this.$('#inputName').val().trim()=="") {
                this.$('.form-group.name').addClass('has-error').find('.help-block').text(i18n.msg('pos.validation.notEmpty'));
                validated = false;
            }
            if(this.$('#inputQuantity').val().trim()=="") {
                this.$('.form-group.quantity').addClass('has-error').find('.help-block').text(i18n.msg('pos.validation.notEmpty'));
                validated = false;
            } else if(isNaN(this.$('#inputQuantity').val()) || this.$('#inputQuantity').val() <1){
                this.$('.form-group.quantity').addClass('has-error').find('.help-block').text( i18n.msg('pos.validation.greaterThan', {number:'1'}));
                validated = false;
            }

            if(!validated) {
                return;
            }

            result.done(function(res) {
                if(res.success) {
                    self.$("form").addClass("hidden");
                    self.$('.modal').modal('hide');
                    self.listResource();
                } else {
                    if(res.errors) {
                        alert(res.errors);
                        return;
                    }
                }
            });

            result.fail(function(res) {
                alert(res);
            });

            return false;
        },

        deleteResource: function() {
            var selectedResource = this.$('.booking.selected'), staffId = selectedResource.data('id'),
                result = null, self = this;

            if(!window.confirm(i18n.msg('pos.settings.confirmDelete', [this.model.get('name')]))) {
                return false;
            }

            result = $.post('/booking/deleteResource', {id: this.model.get("id")});

            result.done(function(res) {
                if(res.success) {
                    selectedResource.remove();
                    self.$("form").addClass("hidden");
                    self.$('.modal').modal('hide');
                    self.listResource();
                } else {
                    alert(i18n.msg('pos.setting.user.delete.failed'));
                }
            });

            result.fail(function(res) {
                alert(i18n.msg('pos.setting.user.delete.failed'));
            });

            return false;
        },

        showError: function(errors) {
            if(errors.email) {
                this.$('.form-group.email').addClass('has-error').
                    find('.help-block.error').removeClass('hidden').text(errors.email);
            }

            if(errors.phone) {
                this.$('.form-group.phone').addClass('has-error').
                    find('.help-block').text(errors.phone);
            }
        },

        listResource: function(e){
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            var rest = POS.getRestaurant(), result = $.post('/pos/bookingResourceList', {
                    offset: offset
                }
            );

            result.done(function (res) {
                self.$('.main').empty().append(res);
            });
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/BookingResourceSettingView.js